import React, { useEffect, useState } from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { NavLink } from "react-router-dom";
import arrowRightPurple from "../image/icon/arrowRightPurple.png";
import arrowLeftPurple from "../image/icon/arrowLeftPurple.png";
import { setCanonicalTag } from "./modules/general";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import Slider from "@mui/material/Slider";
import "../styles/features.css";
import "../styles/navLink.css";
import mixImg from "../image/aqsat/mixPhoto.png";

export default function InstallmentSales() {
  const { t, i18n } = useTranslation();
  const MAX = 200;
  const MIN = 5;
  const [val, setVal] = useState(MIN);
  const repaymentNumber = [3, 6, 9, 12];
  const [chooseRepament, setChooseRepament] = useState(3);
  const [qestAmount, setQestAmount] = useState(0);
  const [finalAmount, setFinalAmount] = useState(0);
  const month = [1, 2, 3];
  const [chooseMonth, setChooseMonth] = useState(1);
  const [checkNumber, setCheckNumber] = useState(0);

  useEffect(() => {
    document.title =
      "خرید قسطی گوشی بدون ضامن | خرید اقساطی گوشی موبایل سامسونگ ، اپل ، هوآوی و شیائومی | خرید اقساطی کالای دیجیتال";
    document.getElementById("main-heading").innerHTML =
      "خرید گوشی تلفن همراه با چک صیادی | خرید موبایل اقساطی ";
    document.getElementsByTagName("meta")["description"].content =
      "بدون ضامن و فقط با یک چک صیادی با کمترین پیش پرداخت به صورت اقساط صاحب تلفن همراه هوشمند شوید.";
    document.getElementsByTagName("meta")["keywords"].content =
      "فروش گوشی قسطی | خرید گوشی اقساطی | خرید با اقساط 3 ماهه | خرید تلفن همراه با اقساط یکساله | فروش تلفن همراه هوشمند به صورت قسطی | خرید بدون ضامن موبایل | تحویل فوری گوشی قسطی | اقساط 18 ماهه | بهترین قیمت گوشی قسطی | خرید اقساطی گوشی سامسونگ | خرید قسطی ایفون | خرید اقساطی تلفن اپل | خرید قطی تلفن از سورین | شرکت وب گستران سورین | ";
    document.getElementsByTagName("meta")["author"].content =
      "شرکت وب گستران سورین";
    setCanonicalTag();
  }, []);

  // useEffect(() => {
  //   (function (t, e, n) {
  //     t.yektanetAnalyticsObject = n;
  //     t[n] = t[n] || function () {
  //       t[n].q.push(arguments);
  //     };
  //     t[n].q = t[n].q || [];
  //     var a = new Date();
  //     var r =
  //       a.getFullYear().toString() +
  //       "0" +
  //       a.getMonth() +
  //       "0" +
  //       a.getDate() +
  //       "0" +
  //       a.getHours();

  //     var c = e.getElementsByTagName("script")[0];
  //     var s = e.createElement("script");
  //     s.id = "ua-script-p3jKebFK";
  //     s.dataset.analyticsobject = n;
  //     s.async = 1;
  //     s.type = "text/javascript";
  //     s.src = "https://cdn.yektanet.com/rg_woebegone/scripts_v3/p3jKebFK/rg.complete.js?v=" + r;
  //     c.parentNode.insertBefore(s, c);
  //   })(window, document, "yektanet");
  // }, []);

  useEffect(() => {
    const value = val * 1000000;
    // const tabdil1 = Math.round(((((value * 45) * (chooseRepament + 1)) / 1950) + value) / chooseRepament);
    // const tabdil2 = Math.round(((((value * 90) * ((chooseRepament / 2) + 1)) / 1900) + value) / (chooseRepament / 2));
    // const tabdil3 = Math.round(((((value * 135) * ((chooseRepament / 3) + 1)) / 1850) + value) / (chooseRepament / 3));
    //const tabdil1 = Math.round((value * 0.025) + (value / chooseRepament))
    //const tabdil2 = Math.round((value * 0.06) + (value / (chooseRepament / 2)))
    //const tabdil3 = Math.round((value * 0.1) + (value / (chooseRepament / 3)))

    // const final1 = chooseRepament * tabdil1
    // const final2 = (chooseRepament / 2) * tabdil2
    // const final3 = (chooseRepament / 3) * tabdil3

    // if (chooseMonth === 1) {
    //   setFinalAmount(final1);
    //   setQestAmount(tabdil1);
    // }
    // else if (chooseMonth === 2) {
    //   setQestAmount(tabdil2);
    //   setFinalAmount(final2);
    // }
    // else {
    //   setQestAmount(tabdil3);
    //   setFinalAmount(final3);
    // }

    let soud;
    if (chooseMonth === 1) {
      soud = value * 0.03;
    } else if (chooseMonth === 2) {
      soud = value * 0.032;
    } else {
      soud = value * 0.034;
    }
    const qest = Math.round((value + soud * chooseRepament) / chooseRepament);
    setQestAmount(qest * chooseMonth);
    setFinalAmount(qest * chooseRepament);
    setCheckNumber(chooseRepament / chooseMonth);
  }, [val, chooseRepament, chooseMonth]);

  const texts = [
    t("minPay"),
    t("facilityCeiling"),
    t("cartoon"),
    t("bouncedChecks"),
    t("AcceptableValidation"),
    t("aqsatContact"),
  ];

  const marks = [
    {
      value: MIN,
      label: "",
    },
    {
      value: MAX,
      label: "",
    },
  ];

  const handleChange = (_, newValue) => {
    setVal(newValue);
  };

  const createTerms = () => {
    let result = [];
    texts.map((item, index) => {
      result.push(
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "50px",
            flexDirection: "row",
            marginTop: { xs: "1em", md: "unset" },
          }}
          key={index}
        >
          <FiberManualRecordIcon sx={{ color: "#FF3951", fontSize: "10px" }} />
          <Typography
            component={"h3"}
            sx={{
              textAlign: "justify",
              fontSize: { xs: "12px", sm: "17px", lg: "20px", xl: "22px" },
              padding: "0 10px",
              width: "85%",
              lineHeight: { xs: "20px", md: "35px" },
              fontWeight: "700",
            }}
          >
            {item}
          </Typography>
        </Grid>,
      );
    });
    return result;
  };

  const repaymentPeriodContent = () => {
    let result = [];
    repaymentNumber.map((item, index) => {
      result.push(
        <Grid
          sx={{
            width: { xs: "30%", sm: "20%" },
            display: "flex",
            alignItems: "center",
            height: "40px",
            justifyContent: "center",
            marginTop: { xs: "10px", sm: "unset" },
          }}
          key={index}
        >
          <Button
            style={{
              width: "80%",
              height: "100%",
              border: "1px solid #FF3951",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: chooseRepament === item ? "white" : "#FF3951",
              backgroundColor: chooseRepament === item ? "#FF3951" : "white",
              fontSize: "20px",
              fontWeight: "bold",
            }}
            onClick={() => chooseRepaymentHandler(item)}
          >
            {item}
          </Button>
        </Grid>,
      );
    });
    return result;
  };

  const btnDis = (monthItem) => {
    // return chooseRepament === 3 && (monthItem === 2);
    if (chooseRepament === 2 && monthItem === 3) return true;
    if (chooseRepament === 9 && monthItem === 2) return true;
    if (chooseRepament === 3 && monthItem === 2) return true;
    return false;
  };

  const monthPeriodContent = () => {
    let result = [];
    month.map((item, index) => {
      result.push(
        <Grid
          style={{
            width: "20%",
            display: "flex",
            alignItems: "center",
            height: "100%",
            justifyContent: "center",
          }}
          key={index}
        >
          <Button
            disabled={btnDis(item)}
            style={{
              width: "80%",
              height: "100%",
              border: "1px solid #FF3951",
              borderRadius: "10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: chooseMonth === item ? "white" : "#FF3951",
              backgroundColor: chooseMonth === item ? "#FF3951" : "white",
              fontSize: "20px",
              fontWeight: "bold",
            }}
            onClick={() => chooseMonthHandler(item)}
          >
            {item}
          </Button>
        </Grid>,
      );
    });
    return result;
  };

  const chooseRepaymentHandler = (ch) => {
    setChooseRepament(ch);
    setChooseMonth(1);
  };

  const chooseMonthHandler = (m) => {
    setChooseMonth(m);
  };

  const separator = (value) => {
    value = value.toString();
    var place = 0;
    if (value.includes(".")) {
      place = value.indexOf(".");
      var num1 = value.slice(0, place);
      var num2 = value.slice(place + 1, value.length);
      value = camaInsert(num1, false) + "." + camaInsert(num2, true);
    } else {
      value = camaInsert(value);
    }
    return value;
  };

  function camaInsert(value, after = false) {
    var output = [];
    var outputString = "";
    if (after) {
      for (var i = 1; i <= value.length; i++) {
        if (i % 3 === 0) {
          output.push(value.slice(i - 3, i));
        }
      }
      if (value.length % 3 !== 0) {
        output.push(
          value.slice(value.length - (value.length % 3), value.length),
        );
      }

      for (var j = 0; j < output.length; j++) {
        if (j + 1 < output.length) {
          outputString = outputString + output[j] + ",";
        } else {
          outputString = outputString + output[j];
        }
      }
    } else {
      for (var p = 1; p <= value.length; p++) {
        if (p % 3 === 0) {
          output.push(value.slice(value.length - p, value.length - p + 3));
        }
      }
      if (value.length % 3 !== 0) {
        output.push(value.slice(0, value.length % 3));
      }
      for (var o = output.length - 1; o >= 0; o--) {
        if (o > 0) {
          outputString = outputString + output[o] + ",";
        } else {
          outputString = outputString + output[o];
        }
      }
    }
    return outputString;
  }

  return (
    <>
      <Grid
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          width: "100%",
          direction: i18n.language === "fa" ? "rtl" : "ltr",
        }}
      >
        <Grid
          sx={{
            display: "flex",
            width: "100%",
            backgroundColor: "#EDEDED",
            padding: "15px 0",
            justifyContent: "center",
          }}
        >
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              width: { xs: "95%", md: "86%" },
            }}
          >
            <NavLink className="navlink" to="/">
              <Typography
                component={"p"}
                sx={{ fontSize: "12px", color: "#757575", padding: "0 5px" }}
              >
                {t("mainPage")}
              </Typography>
            </NavLink>
            <ArrowBackIosIcon sx={{ fontSize: "15px" }} />
            <Typography
              component={"p"}
              sx={{ fontSize: "12px", color: "#070707", padding: "0 5px" }}
            >
              {t("installmentSales")}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          sx={{
            backgroundImage: { sm: `url(${mixImg})`, xs: `url(${mixImg})` },
            backgroundPosition: "center",
            backgroundSize: "100% 100%",
            backgroundRepeat: "no-repeat",
            width: "100%",
            height: { xs: "30vh", sm: "60vh", xl: "60vh" },
            justifyContent: i18n.language === "fa" ? "flex-end" : "flex-start",
            display: "flex",
            alignItems: "center",
            mt: "1%",
          }}
        >
          <Grid
            style={{
              width: "40%",
              height: "50%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              component={"h1"}
              sx={{
                color: "#e1b91e",
                fontWeight: "bold",
                display: { xs: "none", sm: "flex" },
                fontSize: {
                  xl: i18n.language === "fa" ? "40px" : "30px",
                  lg: i18n.language === "fa" ? "30px" : "20px",
                  md: i18n.language === "fa" ? "20px" : "17px",
                  xs: i18n.language === "fa" ? "12px" : "9px",
                  sm: i18n.language === "fa" ? "20px" : "15px",
                },
                width: { sm: "100%", md: "80%" },
                textAlign: "center",
                lineHeight: 3,
                marginLeft: "20px",
              }}
            >
              {t("installmentPart1")}
            </Typography>
          </Grid>
        </Grid>
        <Typography
          component={"h6"}
          sx={{
            display: { xs: "flex", sm: "none" },
            color: "#FF3951",
            fontWeight: "bold",
            marginTop: "10px",
            textAlign: "center",
          }}
        >
          {t("installmentPart1")}
        </Typography>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: { xs: "80px", sm: "150px" },
          }}
        >
          <Typography
            component={"img"}
            alt="icon"
            src={arrowRightPurple}
            sx={{
              width: { xs: "14px", sm: "39px", md: "40px", lg: "54px" },
              height: { xs: "17px", sm: "53px", md: "55px", lg: "69px" },
              margin: "0 3px",
            }}
          />
          <Typography
            component={"h2"}
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "12px", sm: "24px", md: "32px" },
            }}
          >
            {t("installmentGeneralCondition")}
          </Typography>
          <Typography
            component={"img"}
            alt="icon"
            src={arrowLeftPurple}
            sx={{
              width: { xs: "14px", sm: "39px", md: "40px", lg: "54px" },
              height: { xs: "17px", sm: "53px", md: "55px", lg: "69px" },
              margin: "0 3px",
            }}
          />
        </Grid>
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            width: "90%",
          }}
        >
          {createTerms()}
        </Grid>
        <Grid
          sx={{
            width: "70%",
            display: "flex",
            justifyContent: "space-evenly",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "center", sm: "unset" },
            marginTop: "2em",
          }}
        >
          <Grid
            sx={{
              bgcolor: "#FF3951",
              width: {
                xs: "150px",
                sm: "120px",
                md: "180px",
                lg: "240px",
                xl: "290px",
              },
              height: { xs: "40px", sm: "45px", md: "50px", lg: "65px" },
              boxShadow: " #FF3951 0px 0px 15px",
              "&:hover": { backgroundColor: "#FF3951" },
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <NavLink
              to="/LaptopPriceList"
              className="navlink"
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                width: "100%",
                justifyContent: "center",
                color: "white",
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "11px",
                    sm: "11px",
                    md: "16px",
                    lg: "18px",
                    xl: "20px",
                  },
                }}
              >
                {t("laptopPriceList")}
              </Typography>
            </NavLink>
          </Grid>
          <Grid
            sx={{
              bgcolor: "#FF3951",
              width: {
                xs: "150px",
                sm: "120px",
                md: "180px",
                lg: "240px",
                xl: "290px",
              },
              height: { xs: "40px", sm: "45px", md: "50px", lg: "65px" },
              boxShadow: " #FF3951 0px 0px 15px",
              "&:hover": { backgroundColor: "#FF3951" },
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: { xs: "1.5em", sm: "unset" },
            }}
          >
            <NavLink
              to="/MobilePhonePriceList"
              className="navlink"
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                width: "100%",
                justifyContent: "center",
                color: "white",
                fontSize: {
                  xs: "7px",
                  sm: "14px",
                  md: "16px",
                  lg: "18px",
                  xl: "20px",
                },
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "11px",
                    sm: "11px",
                    md: "16px",
                    lg: "18px",
                    xl: "20px",
                  },
                }}
              >
                {t("priceList")}
              </Typography>
            </NavLink>
          </Grid>
          <Grid
            sx={{
              bgcolor: "#FF3951",
              width: {
                xs: "150px",
                sm: "120px",
                md: "180px",
                lg: "240px",
                xl: "290px",
              },
              height: { xs: "40px", sm: "45px", md: "50px", lg: "65px" },
              boxShadow: " #FF3951 0px 0px 15px",
              "&:hover": { backgroundColor: "#FF3951" },
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: { xs: "1.5em", sm: "unset" },
            }}
          >
            <NavLink
              to="/GameConsolePriceList"
              className="navlink"
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "row",
                width: "100%",
                justifyContent: "center",
                color: "white",
                fontSize: {
                  xs: "7px",
                  sm: "14px",
                  md: "16px",
                  lg: "18px",
                  xl: "20px",
                },
                textAlign: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "11px",
                    sm: "11px",
                    md: "16px",
                    lg: "18px",
                    xl: "20px",
                  },
                }}
              >
                {t("gameConsolePriceList")}
              </Typography>
            </NavLink>
          </Grid>
        </Grid>
        <Grid
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: { xs: "80px", sm: "150px" },
          }}
        >
          <Typography
            component={"img"}
            alt="icon"
            src={arrowRightPurple}
            sx={{
              width: { xs: "14px", sm: "39px", md: "40px", lg: "54px" },
              height: { xs: "17px", sm: "53px", md: "55px", lg: "69px" },
              margin: "0 3px",
            }}
          />
          <Typography
            component={"h2"}
            sx={{
              fontWeight: "bold",
              fontSize: { xs: "12px", sm: "24px", md: "32px" },
            }}
          >
            {t("installmentCalculator")}
          </Typography>
          <Typography
            component={"img"}
            alt="icon"
            src={arrowLeftPurple}
            sx={{
              width: { xs: "14px", sm: "39px", md: "40px", lg: "54px" },
              height: { xs: "17px", sm: "53px", md: "55px", lg: "69px" },
              margin: "0 3px",
            }}
          />
        </Grid>
        <Grid
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: { xs: "space-evenly", lg: "space-between" },
            width: { xs: "90%", xl: "80%" },
            mt: "1%",
            borderRadius: "20px",
            boxShadow: "0px 0px 16px 0px #FF3951",
            height: { xs: "700px", lg: "550px" },
            flexDirection: { xs: "column", lg: "row" },
          }}
        >
          <Grid
            sx={{
              width: { xs: "90%", lg: "48%" },
              height: { xs: "45%", lg: "80%" },
              flexDirection: "column",
              alignItems: "center",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Grid
              sx={{
                width: "90%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                component={"h2"}
                sx={{
                  fontSize: {
                    xs: "18px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                }}
              >
                {t("mobileAmount")}
              </Typography>
              <Typography
                sx={{
                  fontSize: {
                    xs: "15px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                  color: "#FF3951",
                }}
              >{`${val} ${t("millionToman")}`}</Typography>
            </Grid>
            <Grid
              sx={{ width: "100%", height: { md: "30px", xs: "10px" } }}
            ></Grid>
            <Box sx={{ width: "93%" }}>
              <Slider
                marks={marks}
                step={0.5}
                value={val}
                valueLabelDisplay="auto"
                aria-labelledby="rtl-slider"
                min={MIN}
                max={MAX}
                onChange={handleChange}
                sx={{
                  color: "#FF3951",
                  "& .MuiSlider-markLabelActive": { color: "#FF3951" },
                  "& .MuiSlider-thumb": { background: "#FF3951" },
                  "& .MuiSlider-root": { padding: "0", direction: "rtl" },
                  width: "100%",
                }}
              />
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  variant="body2"
                  onClick={() => setVal(MAX)}
                  sx={{ cursor: "pointer", color: "gray" }}
                >
                  {`${MAX} ${t("millionToman")}`}
                  {/* {MAX} میلیون */}
                </Typography>
                <Typography
                  variant="body2"
                  onClick={() => setVal(MIN)}
                  sx={{ cursor: "pointer", color: "gray" }}
                >
                  {`${MIN} ${t("millionToman")}`}
                  {/* {MIN}میلیون */}
                </Typography>
              </Box>
            </Box>
            <Grid
              sx={{ width: "100%", height: { md: "30px", xs: "10px" } }}
            ></Grid>
            <Grid sx={{ width: "90%" }}>
              <Typography
                sx={{
                  fontSize: {
                    xs: "18px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                  textAlign: i18n.language === "fa" ? "right" : "left",
                }}
              >
                {t("repaymentPeriod")}
              </Typography>
            </Grid>
            <Grid
              sx={{ width: "100%", height: { md: "50px", xs: "10px" } }}
            ></Grid>
            <Grid
              sx={{
                width: "95%",
                justifyContent: "space-between",
                flexDirection: "row",
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {repaymentPeriodContent()}
            </Grid>
            <Grid
              sx={{ width: "100%", height: { md: "30px", xs: "10px" } }}
            ></Grid>
            <Grid sx={{ width: "90%" }}>
              <Typography
                sx={{
                  fontSize: {
                    xs: "18px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                  textAlign: i18n.language === "fa" ? "right" : "left",
                }}
              >
                {t("installmentInterval")}
              </Typography>
            </Grid>
            <Grid
              sx={{ width: "100%", height: { md: "50px", xs: "10px" } }}
            ></Grid>
            <Grid
              style={{
                width: "95%",
                justifyContent: "space-between",
                height: "40px",
                flexDirection: "row",
                display: "flex",
              }}
            >
              {monthPeriodContent()}
            </Grid>
          </Grid>
          <Grid
            sx={{
              width: { xs: "90%", lg: "48%" },
              height: { xs: "45%", lg: "80%" },
              flexDirection: "column",
              alignItems: "center",
              display: "flex",
              justifyContent: { xs: "space-evenly", sm: "space-between" },
            }}
          >
            <Grid
              sx={{
                width: "90%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                justifyContent: { xs: "space-evenly", sm: "space-between" },
              }}
            >
              <Typography
                component={"h4"}
                sx={{
                  fontSize: {
                    xs: "16px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                }}
              >
                {chooseMonth === 1
                  ? t("eachInstallments")
                  : chooseMonth === 2
                    ? t("eachInstallments2")
                    : t("eachInstallments3")}
              </Typography>
              <Typography
                component={"h5"}
                sx={{
                  fontSize: {
                    xs: "16px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                  color: "#FF3951",
                  marginTop: { xs: "10px", sm: "0px" },
                }}
              >{`${separator(qestAmount)} ${t("toman")}`}</Typography>
            </Grid>
            <Grid
              sx={{
                width: "90%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                justifyContent: { xs: "space-evenly", sm: "space-between" },
              }}
            >
              <Typography
                component={"h4"}
                sx={{
                  fontSize: {
                    xs: "16px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                }}
              >
                {t("NumberOfChecks")}
              </Typography>
              <Typography
                component={"h5"}
                sx={{
                  fontSize: {
                    xs: "16px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                  color: "#FF3951",
                  marginTop: { xs: "10px", sm: "0px" },
                }}
              >{`${separator(checkNumber)}  ${t("faqare")}`}</Typography>
            </Grid>
            <Grid
              sx={{
                width: "90%",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                alignItems: "center",
                justifyContent: { xs: "space-evenly", sm: "space-between" },
              }}
            >
              <Typography
                component={"h4"}
                sx={{
                  fontSize: {
                    xs: "16px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                }}
              >
                {t("finalPayment")}
              </Typography>
              <Typography
                component={"h5"}
                sx={{
                  fontSize: {
                    xs: "16px",
                    md: "23px",
                    lg: i18n.language === "fa" ? "30px" : "20px",
                  },
                  fontWeight: "bold",
                  color: "#FF3951",
                  marginTop: { xs: "10px", sm: "0px" },
                }}
              >{`${separator(finalAmount)} ${t("toman")}`}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid sx={{ width: "100%", height: "100px" }}></Grid>
        <Grid
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "flex-start",
            flexDirection: "column",
            width: "90%",
            margin: { sm: "50px 0px" },
          }}
        >
          <Typography
            component={"h2"}
            sx={{
              fontSize: { xs: "16px", sm: "18px", md: "25px" },
              color: "text.primary",
              margin: "10px 0",
              display: "none",
            }}
          >
            خرید قسطی موبایل :
          </Typography>
          <Typography sx={{ display: "none" }}>
            به دلیل افزایش قیمت تلفن های هوشمند همراه شرکت وب گستران سورین اقدام
            به فروش اقساطی انواع تلفن همراه کرده است. به همین منظور خرید قطی
            موبایل یا خرید اقساطی گوشی تلفن همراه به سادگی میسر شده است. شما می
            توانید با پرداخت مبلغ ناچیز صاحب تلفن همراه شده و اقسط آنرا در مدت
            های 3، 6، 12، 16، 18، 24 ماه پرداخت کنید.
          </Typography>
          <Typography
            component={"h2"}
            sx={{
              fontSize: { xs: "16px", sm: "18px", md: "25px" },
              color: "text.primary",
              margin: "10px 0",
              display: "none",
            }}
          >
            فروش اقساطی تلفن همراه :
          </Typography>
          <Typography sx={{ display: "none" }}>
            شرکت وب گستران سورین به منظور رفاه حال هم وطنان ایرانی اقدام به فروش
            اقساطی تلفن همراه کرده است. متقاضیان می توانند با پرداخت حداقل 20
            درصد پیش پرداخت (بسته به قیمت گوشی و نمراه اعتبار سنجی) و یک برگ چک
            صیادی صاحب گوشی همراه اخرین مدل شوید.
          </Typography>
          <Typography
            component={"h2"}
            sx={{
              fontSize: { xs: "16px", sm: "18px", md: "25px" },
              color: "text.primary",
              margin: "10px 0",
              display: "none",
            }}
          >
            خرید اقساطی ایفون :
          </Typography>
          <Typography sx={{ display: "none" }}>
            هم اکنون می توانید با ثبت درخواست خرید قسطی گوشی در وب سایت وب
            گستران سورین گوشی ایفون مدنظر خود را به صورت اقساط تهیه کرده و با
            پرداخت ماهانه مبلغ ناچیز صاحب تلفن همراه هوشمند شرکا اپل شوید.
          </Typography>
          <Typography
            component={"h2"}
            sx={{
              fontSize: { xs: "16px", sm: "18px", md: "25px" },
              color: "text.primary",
              margin: "10px 0",
              display: "none",
            }}
          >
            خرید قسطی گوشی سامسونگ :
          </Typography>
          <Typography sx={{ display: "none" }}>
            از آنجاییکه تلفن همراه سامسونگ بیشترین طرفدار را در ایران و در دنیا
            دارد، وب گستران سورین امکان خرید انواع گوشی موبایل همراه سامسونگ را
            فراهم کرده است.گوشی های تلفن همراه سامسونگ با تنوع بالا سعی کرده
            تمام اقشار جامعه را به دایره هدف خود نزدیک کند. ما پیشنهاد میکنیم
            برای خرید اقساط گوشی موبایل سامسونگ از وب گستران با اعتبار بالا تهیه
            کنید.
          </Typography>
          <Typography
            component={"h2"}
            sx={{
              fontSize: { xs: "16px", sm: "18px", md: "25px" },
              color: "text.primary",
              margin: "10px 0",
              display: "none",
            }}
          >
            خرید قسطی گوشی شیائومی :
          </Typography>
          <Typography sx={{ display: "none" }}>
            برند شیائومی امکانات زیاد را با قیمت پایین در اختیار کاربران می
            گذارد بدین تریتب توانسته با دو غول بزرگ صنعت تلفن های هوشمند تا
            حدودی همراهی کند . تمام مردم ایران میتوانند با وب گستران سورین صاحب
            یکی از گوشی های شیائومی شوند.
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}
